import { ThemeIcon } from '@mantine/core'
import ThemeIconClasses from './styles.module.css'
import '../../styles/variables.css'

export default ThemeIcon.extend({
    defaultProps: { radius: 'var(--gm-radius-round)' },
    classNames: ThemeIconClasses,
})
